import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { AUTH_SAVE } from "../../../constants/constants";
import { toast } from "../../../lib/toast";
import {
  AuthUser,
  CommonOthers,
  ErrorMessage,
  GetSingleDataParams,
  LoginActionType,
  LoginData,
  PostRequest,
  UpdatePassword,
} from "../../../types";
import { handleApiError } from "../../../utils/errorHandler";

// login user
export const loginUserAsync = createAsyncThunk<
  LoginActionType<AuthUser>,
  PostRequest<LoginData, CommonOthers>,
  {
    rejectValue: ErrorMessage;
  }
>(
  "login/loginUser",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      // const loginData = await AXIOS.post(BASE_API.login, data, {
      //   baseURL: "https://staging-agibackend-api.retail-x.org",
      // });

      const loginData = await AXIOS.post(BASE_API.login, data);

      const responseData = {
        token: loginData?.data?.data?.access_token,
        data: loginData?.data?.data?.user,
        // siteRole: loginData?.data?.data?.user?.role || "ADMIN",
      };

      if (responseData?.token && responseData?.data) {
        AXIOS.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${responseData?.token}`;

        localStorage.setItem(`${AUTH_SAVE}`, JSON.stringify(responseData));
      }

      reRender(true);
      toast("success", "Login successfully");

      return responseData as LoginActionType<AuthUser>;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      // Handle multiple error messages
      handleApiError(error, "Login failed");
      return rejectWithValue(error);
    }
  }
);

// update
export const updatePasswordAsync = createAsyncThunk<
  null,
  PostRequest<UpdatePassword, GetSingleDataParams>
>(
  "admin/updatePassword",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updatePassword}`, data);

      reRender && reRender(true);
      toast("success", "Update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      // Handle multiple error messages
      handleApiError(error, "Update failed");
      return rejectWithValue(error);
    }
  }
);
